import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {CA} from '../analytics/Analytics'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {ViewPopupLogin} from '../ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {ViewPopup} from '../ui_popup/ViewPopup'
import {getNestedTranslation, TranslationObject} from '@colonist/i18n'
import {ClientUserState} from '../ClientUserState'
import {PaymentMethod} from '../../../../shared/store/BaseColonistStoreProduct'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'

export function doActionIfLoggedIn(action: () => void) {
    if(ClientUserState.userState?.isLoggedIn) {
        action()
        return
    }
    if(UIUtilsEjsVariables.isUserOnDiscord) {
        action()
        return
    }
    CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreRequestedLogin)
    new ViewPopupLogin()
}

function canBuy(price: number): boolean {
    if(ClientUserState.userState == undefined) return false
    if(ClientUserState.userState.items.colonistCoins == undefined) return true
    if(ClientUserState.userState.items.colonistCoins >= price) return true
    return false
}

export function areYouSureToBuy(itemDetail: BaseStoreItem, action: () => void, onFailure?: () => undefined) {
    const price = itemDetail.salePrice == undefined ? itemDetail.price : itemDetail.salePrice
    if(!canBuy(price)) {
        if(onFailure) {
            onFailure()
            return
        }

        const coinSection = document.getElementById('coins')
        coinSection?.scrollIntoView({behavior: 'smooth'})
        return
    }

    const popupBody = getNestedTranslation({
        key: 'strings:storePage.purchaseItem?.body',
        options: {
            price: price,
        }}, {itemName: itemDetail.name})
    const popup = new ViewPopup({key: 'strings:storePage.purchaseItem?.title'}, popupBody, () => {
        action()
    }, () => undefined, true)
    popup.show()
}

export function areYouSureToBuyFounderDiscount(itemDetail: BaseStoreItem, action: () => void) {
    const popup = new ViewPopup({key: 'strings:storePage.purchaseItem?.title'}, {key: 'strings:storePage.purchaseItem?.body', options: {context: 'founder'}}, () => {
        action()
    }, () => undefined, true)
    popup.show()
}

export function doActionIfCanGiftMembership(action: () => void, receiverUsername?: string) {
    if(!ClientUserState.userState?.isLoggedIn) {
        new ViewPopupLogin()
        return
    }
    if(receiverUsername?.includes('#')) {
        new ViewPopup({key: 'strings:popups.errors.giftMembership.title'}, {key: 'strings:popups.errors.giftMembership.guestsCantReceiveGifts'}, () => undefined, () => undefined, false, {showXButton: false}).show()
        return
    }

    action()
}

export function getManageSubscriptionPopupBody(): TranslationObject {
    const paymentMethod = ClientUserState.userState?.items.membershipPaymentMethod
    const isNonDiscordMembership = paymentMethod != PaymentMethod.Discord

    if(isNonDiscordMembership) return {key: 'strings:storePage.manageMembership.body', options: {context: 'updateOnWeb'}}

    const discordMembership = ClientUserState.userState?.items.getCurrentMembership()
    if(discordMembership == undefined) throw new Error('Membership not found')

    const hasDiscordAnnualMembership = ColonistMembershipProduct.isAnnualMembership(discordMembership.type)
    if(hasDiscordAnnualMembership) return {key: 'strings:storePage.manageMembership.body', options: {context: 'waitForExpiration'}}

    return {key: 'strings:storePage.manageMembership.body'}
}
